    <template>
  <div>
    <b-modal id="editUserDetails" size="მდ" class="modal has-overflow">
       <template v-slot:modal-header>
        <div class="w-100">
          <h4 class="e-mtavr-17 e-bold modal-title">მომხმარებელი დეტალების ცვლილება</h4>
        </div>
      </template>
      <form autocomplete="off">
        <div class="row no-gutters row-bordered">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pr-3">

            <b-form-group
              label="სახელი"
              class="e-nusx-8 e-bold text-muted"
            >
              <b-input v-model="EditUserDetails.firstName" class="e-eng-font" />
            </b-form-group>
            <b-form-group
              label="გვარი"
              class="e-nusx-8 e-bold text-muted"
            >
              <b-input v-model="EditUserDetails.lastName" class="e-eng-font" />
            </b-form-group>
            <!-- <b-form-group label="პოზიცია" class="e-nusx-8 e-bold text-muted">
            <b-select value="აირჩიეთ პოზიცია" v-model="EditUserDetails.positionID" :options="positions" />
          </b-form-group> -->
          <!-- </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-3">
            <h5
                class="text-center py-4 px-4 px-sm-5 m-0 e-mtavr-14 text-muted"
              >სისტემური პარამეტრები</h5>
              <hr class="border-light m-0 mb-3" /> -->
              <b-form-group label="მომხმარებლის სახელი (UserName)" class="e-nusx-8 text-muted">
            <b-input-group>
              <b-input placeholder="username" name="aadd" type="text" disabled v-model="EditUserDetails.userName" autocomplete="nope"/>
            </b-input-group>
          </b-form-group>
              <b-form-group
              label="მომხმარებლის პაროლი"
              class="e-nusx-8 e-bold text-muted"
            >
             <b-input-group>
              <b-input placeholder="" type="password" v-model="EditUserDetails.password"/>
            </b-input-group>
            </b-form-group>
<!-- <b-form-group
              label="გაიმეორეთ პაროლი"
              class="e-nusx-8 e-bold text-muted"
            >
              <b-input type="password" v-model="EditUserDetails.rePassword" class="e-eng-font"/>
            </b-form-group> -->
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
            <div class="callout callout-primary" v-if="standartPasswordGenerated">
              <h5 class="e-nusx-8 e-bold"><i><small>შენიშვნა</small></i></h5>
              <p class="e-nusx-8"><small>გაცნობებთ, რომ თქვენს მიერ მოხდა მომხმარებლისთვის სტანდარტული პაროლის გენერაცია. რეკომენდირებულია მომხმარებელმა შეცვალოს პაროლი პირველივე შესვლისას</small></p>
              <hr>
              <p class="e-nusx-8">დაგენერირებული პაროლი: <strong> {{newUserItem.user.password}}</strong></p>
            </div>
          </div>
        </div>
      </form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            size="sm"
            variant="btn btn-primary"
            @click="save()"
            class="float-right e-mtavr-17"
            >შენახვა</b-button
          >
          <b-button
            size="sm"
            variant="btn btn-secondary"
            @click="close('editUserDetails')"
            class="float-right e-mtavr-17 mr-2"
            >გაუქმება</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import BaseService from '@/backend/vue-axios/axios.js'
export default {
  name: 'EditUserModal',
  props: ['EditUserDetails'],
  data () {
    return {
      usernameIsValid: undefined,
      usernameChecked: undefined,
      standartPasswordGenerated: false,
      showDetails: false,
      positions: [
        {
          value: null,
          text: 'აირჩიეთ პოზიცია'
        },
        {
          value: 1008,
          text: 'AML სისტემის ადმინისტრატორი'
        },
        {
          value: 1009,
          text: 'AML ჯგუფის უფროსი'
        },
        {
          value: 1010,
          text: 'AML ოფიცერი'
        },
        {
          value: 1011,
          text: 'AML მომხმარებელი'
        }
      ],
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      }
    }
  },
  created () {
    this.EditUserDetails.password = ''
  },
  methods: {
    close (id) {
      this.showDetails = false
      this.$bvModal.hide(id)
    },
    save () {
      // BaseService.EditUser(this.header, this.EditUserDetails)
      //   .then(res => {
      //     if (res.data.success) {
      //       this.EditUserDetails = {}
      //       this.$bvModal.hide('editUserDetails')
      //     }
      //   })
      if (this.EditUserDetails.password === undefined || this.EditUserDetails.password === '') {
        BaseService.EditUser(this.header, this.EditUserDetails)
          .then(res => {
            if (res.data.success) {
              this.EditUserDetails = {}
              this.$bvModal.hide('editUserDetails')
            }
          })
      } else {
        BaseService.ChangePassword(this.header, this.EditUserDetails)
          .then(res => {
            if (res.data.success) {
              this.changePasswordParams = {}
              this.$bvModal.hide('editUserDetails')
            }
          })
      }
    }
  }
}
</script>
